
function onCartChange(data) {

  var cek = data[0].checked;
  console.log(cek);
  if(cek){
    addItemToCart(data[0].value, 1);
    
  }else{
    removeItemFromCart(data[0].value);
   
    
  }
}


function removeItemFromCart(event) {
 event.preventDefault();

 const targetElement = event.target;
 const variantId = targetElement.getAttribute('variant-id');
 
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
  }).then((data) => {
    refreshDrawer();
  });
}

function addItemToCart(variant_id, qty) {

  data = {
    "id": variant_id,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
    refreshDrawer();  

    }   
    
  }); 
 
}

function refreshDrawer() {
        jQuery.ajax({
   url:'/cart',
   type:'GET',
   dataType:'html',
   success: function(data){
       var newDrawer = jQuery(data).find(".cart--root[data-view='drawer']");
     console.log(newDrawer);
     jQuery('.cart--root[data-view="drawer"]').html(newDrawer.html());
     
       }
    });
}
